import { defineStore } from 'pinia'

interface IMicroAppState {
  isMicroApp: boolean,
}
export const useMicroAppStore = defineStore('microApp', {
  state: (): IMicroAppState => {
    return {
      isMicroApp: false
    }
  },
  actions: {
    setMicroApp(stateData: boolean) {
      console.log('setMicroApp', stateData)
      this.isMicroApp = stateData
    }
  }
})
